import React, { useState, useEffect } from "react";
import { connect ,useSelector} from "react-redux";

import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Chip,
    Button,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    Paper,
    TablePagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import VisibilityIcon from "@material-ui/icons/Visibility";

import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";

const FurnitureOneApproval = (props) => {
    const [approvalData, setApprovalData] = useState([]);
    const [selectedQuote, setSelectedQuote] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const {userDetails} = useSelector(state => state.user)
    const isAGMDGM =  userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales")) || userDetails?.roles?.some((role) => role?.name?.includes("AGM Sales"));

    // New state configurations to handle action confirmation workflows
    const [confirmationDialog, setConfirmationDialog] = useState({
        open: false,
        quoteId: null,
        isApproveAction: true, // true for Approve, false for Reject
        discountPercent: 0,
        leadNumber: ""
    });

    const rowsPerPage = 50;

   useEffect(() => {
    getDiscountApprovalDataForFurnitureOneFunc();
}, [page]);

    const getDiscountApprovalDataForFurnitureOneFunc = async () => {
        try {
            // props.setLoading(true);
            setLoading(true);
            const response =
                await HttpService.getDiscountApprovalDataForFurnitureOne(
                    page + 1,
                    rowsPerPage
                );

            setApprovalData(response?.data?.data || []);
            setTotalCount(response?.data?.pagination?.totalCount || 0);
            
            setLoading(false);
        } catch (error) {
            props.setSnackInfo(
                "Failed to fetch approval requests",
                "error"
            );
        } finally {
            setLoading(false);
            // props.setLoading(false);
        }
    };

    // Opens the dialog window and captures contextual details
    const openConfirmationModal = (quote, isApproveAction) => {
        setConfirmationDialog({
            open: true,
            quoteId: quote._id,
            isApproveAction: isApproveAction,
            discountPercent: quote.discountApprovalStatus?.discountPercent || 0,
            leadNumber: quote?.leadId?.uniqueLeadNumber || "-"
        });
    };

    const closeConfirmationModal = () => {
        setConfirmationDialog({
            open: false,
            quoteId: null,
            isApproveAction: true,
            discountPercent: 0,
            leadNumber: ""
        });
    };

    // Submits the payload only when clicking confirm inside the dialog
    const handleConfirmAction = async () => {
        const { quoteId, isApproveAction } = confirmationDialog;
        closeConfirmationModal(); 

        try {
            props.setLoading(true);
            const res = await HttpService.approveRejectDiscountForFurnitureOne({
                quoteId,
                response: isApproveAction, 
            });

            props.setSnackInfo(
                res?.data?.message || `Discount request processed successfully`,
                "success"
            );
            getDiscountApprovalDataForFurnitureOneFunc();
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            props.setLoading(false);
        }
    };
    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60vh",
                    fontSize: "1.5rem",
                    fontWeight: "500",
                    color: "#1976d2",
                    fontFamily: "sans-serif",
                    letterSpacing: "0.5px"
                }}
            >
                <div
                    style={{
                        fontSize: "3rem",
                        animation: "flip 1.2s infinite linear",
                        display: "inline-block"
                    }}
                >
                    ⏳
                </div>
                <div style={{ marginTop: "10px" }}>Loading...</div>
                <style>
                    {`
              @keyframes flip {
                0% { transform: rotate(0deg); }
                25% { transform: rotateX(180deg); }
                50% { transform: rotate(180deg); }
                75% { transform: rotateX(360deg); }
                100% { transform: rotate(360deg); }
              }
            `}
                </style>
            </div>
        );
    }

    return (
        <Box p={3} style={{ background: "#f5f7fb", minHeight: "100vh" }}>
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h6" style={{ fontWeight: 400 }}>
                    F1 Discount Approval Requests
                </Typography>
                <Chip label={`${approvalData.length} Pending Requests`} color="primary" />
            </Box>

            {approvalData.length === 0 && (
                <Paper elevation={0} style={{ padding: 50, textAlign: "center", borderRadius: 12 }}>
                    <Typography variant="h6">No Pending Approvals</Typography>
                    <Typography variant="body2" color="textSecondary">
                        All discount requests have been processed.
                    </Typography>
                </Paper>
            )}

            {/* Table  */}
            <TableContainer
                component={Paper}
                elevation={2}
                style={{
                    borderRadius: 12,
                    overflow: "hidden"
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow
                            style={{
                                background: "#f8fafc"
                            }}
                        >
                            <TableCell><b>Lead Number</b></TableCell>
                            <TableCell><b>Customer</b></TableCell>
                            <TableCell><b>Version</b></TableCell>
                            <TableCell><b>Department</b></TableCell>
                            <TableCell><b>Discount</b></TableCell>
                            <TableCell><b>Requested On</b></TableCell>
                            <TableCell><b>Items</b></TableCell>
                            <TableCell align="center"><b>Actions</b></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {approvalData.map((quote)  => {
                            const approval = quote.discountApprovalStatus;
                            const firstItem = quote.items?.[0];

                            return (
                                <TableRow
                                    key={quote._id}
                                    hover
                                >
                                    <TableCell>
                                        <Typography
                                            style={{
                                                fontWeight: 600
                                            }}
                                        >
                                            {quote?.leadId?.uniqueLeadNumber || quote?.leadId?.lead_no }
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Typography>
                                            {quote?.leadId?.customerId?.name || "-"}
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        {quote.version}
                                    </TableCell>

                                    <TableCell>
                                        {approval?.approvalDeptName || "-"}
                                    </TableCell>

                                    <TableCell>
                                        <Chip
                                            size="small"
                                            label={`${approval?.discountPercent || 0}%`}
                                            style={{
                                                fontWeight: 600,
                                                background:
                                                    approval?.discountPercent > 15
                                                        ? "#ffebee"
                                                        : approval?.discountPercent > 5
                                                            ? "#fff3e0"
                                                            : "#e8f5e9",
                                                color:
                                                    approval?.discountPercent > 15
                                                        ? "#c62828"
                                                        : approval?.discountPercent > 5
                                                            ? "#ef6c00"
                                                            : "#2e7d32"
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        {approval?.approvalsendDate
                                            ? new Date(
                                                approval.approvalsendDate
                                            ).toLocaleDateString("en-IN")
                                            : "-"}
                                    </TableCell>

                                    <TableCell>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                        >
                                            <Avatar
                                                variant="rounded"
                                                src={firstItem?.img}
                                                style={{
                                                    width: 36,
                                                    height: 36,
                                                    marginRight: 8
                                                }}
                                            >
                                                {firstItem?.name?.charAt(0)}
                                            </Avatar>

                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    style={{
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {firstItem?.name}
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="textSecondary"
                                                >
                                                    {quote.items?.length} item(s)
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>

                                    <TableCell align="center">

                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            startIcon={<VisibilityIcon />}
                                            style={{
                                                marginRight: 8
                                            }}
                                            onClick={() =>
                                                setSelectedQuote(quote)
                                            }
                                        >
                                            View
                                        </Button>

                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="secondary"
                                            startIcon={<CancelIcon />}
                                            style={{
                                                marginRight: 8
                                            }}
                                            onClick={() =>
                                                openConfirmationModal(
                                                    quote,
                                                    false
                                                )
                                            }
                                        >
                                            Reject
                                        </Button>

                                        <Button
                                            size="small"
                                            variant="contained"
                                            startIcon={<CheckCircleIcon />}
                                            style={{
                                                background: "#2e7d32",
                                                color: "#fff"
                                            }}
                                            onClick={() =>
                                                openConfirmationModal(
                                                    quote,
                                                    true
                                                )
                                            }
                                        >
                                            Approve
                                        </Button>

                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination Controls */}
            <Box mt={2}>
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onChangePage={(event, newPage) => {
                        setPage(newPage);
                    }}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[50]}
                />
            </Box>

            {/* Confirmation Dialog Component */}
            <Dialog
                open={confirmationDialog.open}
                onClose={closeConfirmationModal}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle style={{ fontWeight: 600 }}>
                    Confirm Action
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Are you sure you want to{" "}
                        <b style={{ color: confirmationDialog.isApproveAction ? "#2e7d32" : "#dc2626" }}>
                            {confirmationDialog.isApproveAction ? "APPROVE" : "REJECT"}
                        </b>{" "}
                        the <b>{confirmationDialog.discountPercent}%</b> discount requested for Lead number{" "}
                        <b>{confirmationDialog.leadNumber}</b>?
                    </Typography>
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px" }}>
                    <Button onClick={closeConfirmationModal} variant="outlined" color="default">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmAction}
                        variant="contained"
                        style={{
                            backgroundColor: confirmationDialog.isApproveAction ? "#2e7d32" : "#dc2626",
                            color: "#fff"
                        }}
                        autoFocus
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Details Structural Dialog */}
            <Dialog open={Boolean(selectedQuote)} onClose={() => setSelectedQuote(null)} maxWidth="md" fullWidth>
                <DialogTitle>Quotation Details</DialogTitle>
                <DialogContent>
                    {selectedQuote?.items?.map((item) => (
                        <Box key={item._id} mb={2}>
                            <Box display="flex" alignItems="center">
                                <Avatar variant="rounded" src={item.img} style={{ width: 70, height: 70, marginRight: 16 }} />
                                <Box>
                                    <Typography style={{ fontWeight: 600 }}>{item.name}</Typography>
                                    <Typography variant="body2">Category: {item.category}</Typography>
                                    <Typography variant="body2">Quantity: {item.quantity}</Typography>
                                    <Typography variant="body2">
                                        {item.label_rate > item.price && (
                                            <span style={{ textDecoration: 'line-through', color: '#ff0000ff', marginRight: 6 }}>
                                                ₹{item.label_rate?.toLocaleString('en-IN')}
                                            </span>
                                        )}
                                        <span style={{ fontWeight: 600, color: '#1B2A4A' }}>
                                            ₹{item.price?.toLocaleString('en-IN')}
                                        </span>
                                        {item.label_rate > item.price && (
                                            <span style={{ marginLeft: 6, fontSize: 11, color: '#10B981', fontWeight: 600 }}>
                                                ({Math.round(((item.label_rate - item.price) / item.label_rate) * 100)}% off MRP)
                                            </span>
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider style={{ marginTop: 12 }} />
                        </Box>
                    ))}
                    {(() => {
                        const subtotal = selectedQuote?.items?.reduce((s, i) => s + (i.price * i.quantity), 0) || 0;
                        const discountPercent = selectedQuote?.discountApprovalStatus?.discountPercent || 0;
                        const discountAmount = Math.round(subtotal * discountPercent / 100);
                        const grandTotal = subtotal - discountAmount;

                        return (
                            <Box mt={2} p={2} style={{ background: '#F8F9FD', borderRadius: 10, border: '1px solid #EAEFF8' }}>
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2" color="textSecondary">Subtotal</Typography>
                                    <Typography variant="body2" style={{ fontWeight: 600 }}>
                                        ₹{subtotal.toLocaleString('en-IN')}
                                    </Typography>
                                </Box>
                                {discountPercent > 0 && (
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Discount ({discountPercent}%)
                                        </Typography>
                                        <Typography variant="body2" style={{ fontWeight: 600, color: '#EF4444' }}>
                                            −₹{discountAmount.toLocaleString('en-IN')}
                                        </Typography>
                                    </Box>
                                )}
                                <Divider style={{ margin: '8px 0' }} />
                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="body1" style={{ fontWeight: 700 }}>Grand Total</Typography>
                                    <Typography variant="body1" style={{ fontWeight: 800, color: '#1B2A4A', fontSize: 18 }}>
                                        ₹{grandTotal.toLocaleString('en-IN')}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })()}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

const mapDispatchToProps = {
    setLoading,
    setSnackInfo
};

export default connect(null, mapDispatchToProps)(FurnitureOneApproval);